import {
  type FetchResult,
  type MutationResult,
  type SetInboxMessageClassificationMutation,
  type SetMessageClassificationInput,
  useSetInboxMessageClassificationMutation,
} from "@qw/graphql";
import { useToast } from "@qw/ui";
import { useCallback } from "react";

export type UseSetMessageClassificationReturn = [
  (input: SetMessageClassificationInput) => Promise<FetchResult<SetInboxMessageClassificationMutation> | undefined>,
  MutationResult<SetInboxMessageClassificationMutation>,
];

export const useSetMessageClassification = (): UseSetMessageClassificationReturn => {
  const { toast } = useToast();
  const [setClassificationMutation, result] = useSetInboxMessageClassificationMutation();

  const setClassification = useCallback(
    (input: SetMessageClassificationInput) =>
      setClassificationMutation({
        variables: { input },
        onError: (error) => {
          toast({
            title: "Error updating classification",
            description: error instanceof Error ? error.message : "An unexpected error occurred",
            variant: "destructive",
          });
        },
        onCompleted: () => {
          toast({
            title: "Classification updated",
            description: "Message classification has been updated successfully",
          });
        },
        refetchQueries: ["InboxConversation", "InboxMessage"],
      }),
    [setClassificationMutation, toast]
  );

  return [setClassification, result];
};
